import { useRef } from 'react';
import { motion, useInView } from 'framer-motion';

const clients = [
  'Campa Cola', 'Reliance Retail', 'Reliance Brands', 'DTDC',
  'Reliance Digital', 'Hamleys',
];

const campaigns = [
  'Beach Cleanup Campaigns',
  'Glass & Plastic Waste Collection Drive',
  'Swachh Initiatives',
  'Community Awareness Programs',
];

export function Clients() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-80px' });

  return (
    <section ref={ref} className="py-20 lg:py-28 bg-white overflow-hidden">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.5 }}
          className="mb-12"
        >
          <p className="text-xs font-semibold tracking-widest uppercase text-gray-400 mb-4">
            Clients & Campaigns
          </p>
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900">
            Trusted by businesses across India.
          </h2>
        </motion.div>
      </div>

      {/* Marquee rows — centered start */}
      <div className="space-y-4 mb-12">
        <div className="flex justify-center overflow-hidden">
          <div className="ticker-track">
            {[...clients, ...clients, ...clients, ...clients].map((client, i) => (
              <span
                key={i}
                className="ticker-item px-8 py-3 border border-gray-100 rounded-full text-sm font-semibold text-gray-700 mx-2 whitespace-nowrap bg-white shadow-sm"
              >
                {client}
              </span>
            ))}
          </div>
        </div>
        <div className="flex justify-center overflow-hidden">
          <div className="ticker-track ticker-reverse">
            {[...clients, ...clients, ...clients, ...clients].map((client, i) => (
              <span
                key={i}
                className="ticker-item px-8 py-3 border border-gray-100 rounded-full text-sm font-semibold text-gray-700 mx-2 whitespace-nowrap bg-white shadow-sm"
              >
                {client}
              </span>
            ))}
          </div>
        </div>
      </div>

      {/* Community campaigns */}
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.5, delay: 0.2 }}
          className="border-t border-gray-100 pt-10"
        >
          <p className="text-xs font-semibold tracking-widest uppercase text-gray-400 mb-5">
            Community Campaigns
          </p>
          <div className="flex flex-wrap gap-3 mb-8">
            {campaigns.map((c) => (
              <span
                key={c}
                className="px-4 py-2 bg-p-50 border border-p-100 rounded-full text-sm font-medium text-p-700"
              >
                {c}
              </span>
            ))}
          </div>
          <p className="text-2xl lg:text-3xl font-bold text-gray-900">
            8+ years. Structured systems. Measurable outcomes.
          </p>
        </motion.div>
      </div>
    </section>
  );
}
